import type { FieldAnchor } from "web_myplann/Shared/Types/FieldAnchor";
import { getFocusedField } from "web_myplann/Shared/Utils/getFocusedField";
import { getScrollContainer } from "web_myplann/Shared/Utils/getScrollContainer";

const FIELD_MARGIN_PX = 16;

export const createFieldAnchor = (
	visibleHeight: number,
): FieldAnchor | null => {
	const field = getFocusedField();
	const scroller = getScrollContainer(field);
	if (!field || !scroller) {
		return null;
	}

	const { top, height } = field.getBoundingClientRect();
	const lowestVisibleTop = visibleHeight - height - FIELD_MARGIN_PX;

	return {
		field,
		scroller,
		top: Math.max(0, Math.min(top, lowestVisibleTop)),
	};
};
